import {
  DefaultActions,
  ReportActionsPropsUnion,
  ReportActionsSideBarContainer,
} from './components';

export function ReportActionsSideBar({
  children,
  reportPermaLink,
  reportType,
  reportTitle,
  deleteCurrentReport,
  reportUpgraded,
}: ReportActionsPropsUnion) {
  return (
    <ReportActionsSideBarContainer data-cy="recent_reports_rats">
      {reportPermaLink && reportType && reportTitle ? (
        <DefaultActions
          reportPermaLink={reportPermaLink}
          reportType={reportType}
          reportTitle={reportTitle}
          deleteCurrentReport={deleteCurrentReport}
          reportUpgraded={reportUpgraded}
        />
      ) : (
        <>{children}</>
      )}
    </ReportActionsSideBarContainer>
  );
}
